"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../../../styles");

var styles = {
  root: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    color: _styles.colors.ash,
    textTransform: 'uppercase',
    fontWeight: 700,
    fontSize: '12px',
    height: '100%',
    padding: '15px 5px',
    margin: '0px 15px',
    borderBottom: '4px solid transparent',
    transition: 'all 250ms',
    '&:hover': {
      color: function color(_ref) {
        var selected = _ref.selected;
        return selected ? '' : _styles.colors.charcoal;
      }
    },
    '&:focus': {
      outline: 'none',
      color: function color(_ref2) {
        var selected = _ref2.selected;
        return selected ? '' : _styles.colors.charcoal;
      }
    }
  },
  selected: {
    color: _styles.colors.black,
    borderBottomColor: _styles.colors.blue
  }
};
var _default = styles;
exports["default"] = _default;